export interface VideoItem {
  id: number;
  title: string;
  author: string;
  category: string;
  tags: string[];
  duration: string;
  views: string;
  cover: string;
  desc: string;
  hot: number;
}

export interface RankingItem {
  rank: number;
  title: string;
  author: string;
  category: string;
  views: string;
  trend: "up" | "flat" | "down";
  cover: string;
}

export interface CollectionItem {
  id: number;
  name: string;
  count: string;
  theme: string;
  desc: string;
  cover: string;
  tags: string[];
}

export interface CreatorItem {
  id: number;
  name: string;
  field: string;
  followers: string;
  works: string;
  avatar: string;
  bio: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const categories: string[] = [
  "全部",
  "美食",
  "旅行",
  "手工",
  "宠物",
  "数码",
  "搞笑",
  "知识",
  "音乐",
  "生活",
];

export const heroTags: string[] = ["治愈", "美食", "旅行", "萌宠", "城市漫游", "知识"];

export const quickStats = [
  { value: "1,280+", label: "今日聚合合集" },
  { value: "24h", label: "榜单滚动更新" },
  { value: "18", label: "内容大分类" },
  { value: "100%", label: "本页可直接浏览" },
];

export const videos: VideoItem[] = [
  {
    id: 1,
    title: "深夜厨房：一人食的温柔料理",
    author: "阿凉的小厨房",
    category: "美食",
    tags: ["美食", "治愈", "独居"],
    duration: "08:24",
    views: "128.6万",
    cover: "https://readdy.ai/api/search-image?query=Warm%20close-up%20of%20a%20simple%20home-cooked%20noodle%20bowl%20on%20a%20wooden%20table%20at%20night%2C%20steam%20rising%2C%20soft%20amber%20lamp%20light%2C%20cozy%20minimal%20food%20photography%2C%20muted%20warm%20tones&width=480&height=640&seq=video-food-01&orientation=portrait",
    desc: "一个人吃饭也要认真，从备菜到装盘，十分钟做出一碗有热气的面。",
    hot: 9860,
  },
  {
    id: 2,
    title: "老巷手作：古法琉璃的诞生",
    author: "器物志",
    category: "手工",
    tags: ["手工", "慢生活", "纪录"],
    duration: "12:05",
    views: "86.3万",
    cover: "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20craftsman%20shaping%20molten%20glass%20in%20a%20workshop%2C%20glowing%20orange%20material%2C%20dark%20rustic%20interior%2C%20documentary%20craft%20photography%2C%20warm%20contrast%20lighting&width=480&height=640&seq=video-craft-02&orientation=portrait",
    desc: "从配料到退火，记录一件琉璃器物要经过的十二道工序。",
    hot: 8420,
  },
  {
    id: 3,
    title: "城市漫游：雨天里的旧书店",
    author: "漫游观察",
    category: "生活",
    tags: ["城市漫游", "生活", "Vlog"],
    duration: "06:47",
    views: "54.1万",
    cover: "https://readdy.ai/api/search-image?query=Rainy%20afternoon%20walk%20into%20a%20small%20old%20bookstore%2C%20wet%20street%20reflections%2C%20warm%20interior%20glow%2C%20moody%20urban%20documentary%20photography&width=480&height=640&seq=video-city-03&orientation=portrait",
    desc: "撑着伞拐进巷子，在堆满旧书的角落里坐了一整个下午。",
    hot: 7310,
  },
  {
    id: 4,
    title: "环球脚步：冰岛黑沙滩的清晨",
    author: "行路者阿哲",
    category: "旅行",
    tags: ["旅行", "纪录", "风景"],
    duration: "15:32",
    views: "213.9万",
    cover: "https://readdy.ai/api/search-image?query=Dramatic%20Iceland%20black%20sand%20beach%20at%20sunrise%2C%20basalt%20columns%2C%20soft%20mist%2C%20cinematic%20wide%20landscape%20photography%2C%20cool%20muted%20tones&width=480&height=640&seq=video-travel-04&orientation=portrait",
    desc: "天没亮就出发，在风里等到第一缕光落在玄武岩柱上。",
    hot: 9540,
  },
  {
    id: 5,
    title: "萌宠日记：橘猫的午后哲学",
    author: "喵星研究所",
    category: "宠物",
    tags: ["萌宠", "治愈", "搞笑"],
    duration: "04:18",
    views: "301.2万",
    cover: "https://readdy.ai/api/search-image?query=Fluffy%20orange%20tabby%20cat%20napping%20in%20a%20sunny%20window%2C%20soft%20warm%20light%2C%20cozy%20home%20interior%2C%20gentle%20cute%20pet%20photography&width=480&height=640&seq=video-pet-05&orientation=portrait",
    desc: "一整个下午，它只做了三件事：睡、翻面、继续睡。",
    hot: 9970,
  },
  {
    id: 6,
    title: "硬核拆解：千元耳机的内部结构",
    author: "拆解君",
    category: "数码",
    tags: ["数码", "开箱", "教程"],
    duration: "09:51",
    views: "97.5万",
    cover: "https://readdy.ai/api/search-image?query=Disassembled%20wireless%20earbuds%20laid%20out%20on%20a%20clean%20mat%2C%20precision%20tools%2C%20neat%20studio%20top-down%20tech%20photography%2C%20neutral%20gray%20background&width=480&height=640&seq=video-tech-06&orientation=portrait",
    desc: "一颗一颗拆开看，聊聊它为什么能卖到这个价。",
    hot: 7050,
  },
  {
    id: 7,
    title: "街头笑声：地铁里的神回复合集",
    author: "每日一笑",
    category: "搞笑",
    tags: ["搞笑", "合集"],
    duration: "05:03",
    views: "456.7万",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20colorful%20abstract%20pop%20collage%20with%20speech%20bubbles%20and%20confetti%20shapes%2C%20playful%20upbeat%20graphic%20design%20background%2C%20bright%20yellow%20and%20coral%20tones&width=480&height=640&seq=video-fun-07&orientation=portrait",
    desc: "一秒一个笑点的街头抓拍，记得别在地铁上笑出声。",
    hot: 10000,
  },
  {
    id: 8,
    title: "健身小课：十分钟居家拉伸",
    author: "动起来阿凯",
    category: "运动",
    tags: ["健身", "教程", "生活"],
    duration: "10:40",
    views: "73.8万",
    cover: "https://readdy.ai/api/search-image?query=Person%20stretching%20on%20a%20yoga%20mat%20in%20a%20bright%20minimal%20living%20room%2C%20morning%20light%20through%20sheers%2C%20clean%20wellness%20lifestyle%20photography&width=480&height=640&seq=video-sport-08&orientation=portrait",
    desc: "久坐党友好，不用器械，跟着做完肩颈会松很多。",
    hot: 6820,
  },
  {
    id: 9,
    title: "知识速递：三分钟看懂潮汐成因",
    author: "知识放映厅",
    category: "知识",
    tags: ["知识", "教程"],
    duration: "03:26",
    views: "168.4万",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20minimal%20illustration%20of%20ocean%20tides%20and%20moon%20orbit%2C%20flat%20vector%20science%20diagram%20aesthetic%2C%20deep%20teal%20and%20cream%20palette%2C%20clean%20background&width=480&height=640&seq=video-know-09&orientation=portrait",
    desc: "月亮到底怎么「拉」动海水？用一张动图讲清楚。",
    hot: 8790,
  },
  {
    id: 10,
    title: "音乐现场：天台上的民谣夜",
    author: "城市声场",
    category: "音乐",
    tags: ["音乐", "城市漫游", "治愈"],
    duration: "11:12",
    views: "92.0万",
    cover: "https://readdy.ai/api/search-image?query=Intimate%20acoustic%20guitar%20performance%20on%20a%20rooftop%20at%20dusk%2C%20string%20lights%2C%20city%20skyline%20bokeh%2C%20warm%20cinematic%20music%20photography&width=480&height=640&seq=video-music-10&orientation=portrait",
    desc: "一把琴、一盏串灯，把城市的晚风唱进了歌里。",
    hot: 7240,
  },
  {
    id: 11,
    title: "影单推荐：值得二刷的冷门佳作",
    author: "光影笔记",
    category: "影视",
    tags: ["影视", "推荐"],
    duration: "07:58",
    views: "145.3万",
    cover: "https://readdy.ai/api/search-image?query=Retro%20film%20reel%20and%20cinema%20tickets%20on%20a%20dark%20textured%20surface%2C%20dramatic%20side%20lighting%2C%20moody%20amber%20tones%2C%20editorial%20movie%20recommendation%20aesthetic&width=480&height=640&seq=video-movie-11&orientation=portrait",
    desc: "十部被低估的电影，看完第一遍还会想再看一次。",
    hot: 8110,
  },
  {
    id: 12,
    title: "穿搭灵感：初秋通勤三套搭配",
    author: "衣橱研究员",
    category: "生活",
    tags: ["穿搭", "生活", "教程"],
    duration: "06:11",
    views: "61.7万",
    cover: "https://readdy.ai/api/search-image?query=Autumn%20minimal%20outfit%20flat%20lay%20with%20knitwear%2C%20trench%20coat%20and%20leather%20bag%2C%20warm%20neutral%20earth%20tones%2C%20clean%20editorial%20fashion%20photography&width=480&height=640&seq=video-fashion-12&orientation=portrait",
    desc: "三套不挑身材的通勤搭配，翻出衣柜里已有的单品就能穿。",
    hot: 6390,
  },
];

export const rankingDaily: RankingItem[] = [
  { rank: 1, title: "橘猫的午后哲学", author: "喵星研究所", category: "宠物", views: "301.2万", trend: "up", cover: "https://readdy.ai/api/search-image?query=Fluffy%20orange%20tabby%20cat%20napping%20in%20a%20sunny%20window%2C%20soft%20warm%20light%2C%20cozy%20home%20interior%2C%20gentle%20cute%20pet%20photography&width=200&height=200&seq=rank-pet-a&orientation=squarish" },
  { rank: 2, title: "地铁里的神回复合集", author: "每日一笑", category: "搞笑", views: "456.7万", trend: "flat", cover: "https://readdy.ai/api/search-image?query=Vibrant%20colorful%20abstract%20pop%20collage%20with%20speech%20bubbles%20and%20confetti%20shapes%2C%20playful%20upbeat%20graphic%20design%20background%2C%20bright%20yellow%20and%20coral%20tones&width=200&height=200&seq=rank-fun-a&orientation=squarish" },
  { rank: 3, title: "冰岛黑沙滩的清晨", author: "行路者阿哲", category: "旅行", views: "213.9万", trend: "up", cover: "https://readdy.ai/api/search-image?query=Dramatic%20Iceland%20black%20sand%20beach%20at%20sunrise%2C%20basalt%20columns%2C%20soft%20mist%2C%20cinematic%20wide%20landscape%20photography%2C%20cool%20muted%20tones&width=200&height=200&seq=rank-travel-a&orientation=squarish" },
  { rank: 4, title: "三分钟看懂潮汐成因", author: "知识放映厅", category: "知识", views: "168.4万", trend: "up", cover: "https://readdy.ai/api/search-image?query=Stylized%20minimal%20illustration%20of%20ocean%20tides%20and%20moon%20orbit%2C%20flat%20vector%20science%20diagram%20aesthetic%2C%20deep%20teal%20and%20cream%20palette%2C%20clean%20background&width=200&height=200&seq=rank-know-a&orientation=squarish" },
  { rank: 5, title: "值得二刷的冷门佳作", author: "光影笔记", category: "影视", views: "145.3万", trend: "down", cover: "https://readdy.ai/api/search-image?query=Retro%20film%20reel%20and%20cinema%20tickets%20on%20a%20dark%20textured%20surface%2C%20dramatic%20side%20lighting%2C%20moody%20amber%20tones%2C%20editorial%20movie%20recommendation%20aesthetic&width=200&height=200&seq=rank-movie-a&orientation=squarish" },
  { rank: 6, title: "一人食的温柔料理", author: "阿凉的小厨房", category: "美食", views: "128.6万", trend: "flat", cover: "https://readdy.ai/api/search-image?query=Warm%20close-up%20of%20a%20simple%20home-cooked%20noodle%20bowl%20on%20a%20wooden%20table%20at%20night%2C%20steam%20rising%2C%20soft%20amber%20lamp%20light%2C%20cozy%20minimal%20food%20photography%2C%20muted%20warm%20tones&width=200&height=200&seq=rank-food-a&orientation=squarish" },
];

export const rankingWeekly: RankingItem[] = [
  { rank: 1, title: "冰岛黑沙滩的清晨", author: "行路者阿哲", category: "旅行", views: "1,482.0万", trend: "up", cover: "https://readdy.ai/api/search-image?query=Dramatic%20Iceland%20black%20sand%20beach%20at%20sunrise%2C%20basalt%20columns%2C%20soft%20mist%2C%20cinematic%20wide%20landscape%20photography%2C%20cool%20muted%20tones&width=200&height=200&seq=rank-travel-b&orientation=squarish" },
  { rank: 2, title: "地铁里的神回复合集", author: "每日一笑", category: "搞笑", views: "1,206.5万", trend: "up", cover: "https://readdy.ai/api/search-image?query=Vibrant%20colorful%20abstract%20pop%20collage%20with%20speech%20bubbles%20and%20confetti%20shapes%2C%20playful%20upbeat%20graphic%20design%20background%2C%20bright%20yellow%20and%20coral%20tones&width=200&height=200&seq=rank-fun-b&orientation=squarish" },
  { rank: 3, title: "橘猫的午后哲学", author: "喵星研究所", category: "宠物", views: "998.4万", trend: "flat", cover: "https://readdy.ai/api/search-image?query=Fluffy%20orange%20tabby%20cat%20napping%20in%20a%20sunny%20window%2C%20soft%20warm%20light%2C%20cozy%20home%20interior%2C%20gentle%20cute%20pet%20photography&width=200&height=200&seq=rank-pet-b&orientation=squarish" },
  { rank: 4, title: "古法琉璃的诞生", author: "器物志", category: "手工", views: "742.1万", trend: "up", cover: "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20craftsman%20shaping%20molten%20glass%20in%20a%20workshop%2C%20glowing%20orange%20material%2C%20dark%20rustic%20interior%2C%20documentary%20craft%20photography%2C%20warm%20contrast%20lighting&width=200&height=200&seq=rank-craft-b&orientation=squarish" },
  { rank: 5, title: "天台上的民谣夜", author: "城市声场", category: "音乐", views: "655.8万", trend: "down", cover: "https://readdy.ai/api/search-image?query=Intimate%20acoustic%20guitar%20performance%20on%20a%20rooftop%20at%20dusk%2C%20string%20lights%2C%20city%20skyline%20bokeh%2C%20warm%20cinematic%20music%20photography&width=200&height=200&seq=rank-music-b&orientation=squarish" },
  { rank: 6, title: "千元耳机的内部结构", author: "拆解君", category: "数码", views: "512.3万", trend: "flat", cover: "https://readdy.ai/api/search-image?query=Disassembled%20wireless%20earbuds%20laid%20out%20on%20a%20clean%20mat%2C%20precision%20tools%2C%20neat%20studio%20top-down%20tech%20photography%2C%20neutral%20gray%20background&width=200&height=200&seq=rank-tech-b&orientation=squarish" },
];

export const rankingAll: RankingItem[] = [
  { rank: 1, title: "地铁里的神回复合集", author: "每日一笑", category: "搞笑", views: "8,904.2万", trend: "flat", cover: "https://readdy.ai/api/search-image?query=Vibrant%20colorful%20abstract%20pop%20collage%20with%20speech%20bubbles%20and%20confetti%20shapes%2C%20playful%20upbeat%20graphic%20design%20background%2C%20bright%20yellow%20and%20coral%20tones&width=200&height=200&seq=rank-fun-c&orientation=squarish" },
  { rank: 2, title: "橘猫的午后哲学", author: "喵星研究所", category: "宠物", views: "7,633.9万", trend: "up", cover: "https://readdy.ai/api/search-image?query=Fluffy%20orange%20tabby%20cat%20napping%20in%20a%20sunny%20window%2C%20soft%20warm%20light%2C%20cozy%20home%20interior%2C%20gentle%20cute%20pet%20photography&width=200&height=200&seq=rank-pet-c&orientation=squarish" },
  { rank: 3, title: "冰岛黑沙滩的清晨", author: "行路者阿哲", category: "旅行", views: "5,120.7万", trend: "up", cover: "https://readdy.ai/api/search-image?query=Dramatic%20Iceland%20black%20sand%20beach%20at%20sunrise%2C%20basalt%20columns%2C%20soft%20mist%2C%20cinematic%20wide%20landscape%20photography%2C%20cool%20muted%20tones&width=200&height=200&seq=rank-travel-c&orientation=squarish" },
  { rank: 4, title: "三分钟看懂潮汐成因", author: "知识放映厅", category: "知识", views: "4,388.1万", trend: "down", cover: "https://readdy.ai/api/search-image?query=Stylized%20minimal%20illustration%20of%20ocean%20tides%20and%20moon%20orbit%2C%20flat%20vector%20science%20diagram%20aesthetic%2C%20deep%20teal%20and%20cream%20palette%2C%20clean%20background&width=200&height=200&seq=rank-know-c&orientation=squarish" },
  { rank: 5, title: "一人食的温柔料理", author: "阿凉的小厨房", category: "美食", views: "3,905.6万", trend: "up", cover: "https://readdy.ai/api/search-image?query=Warm%20close-up%20of%20a%20simple%20home-cooked%20noodle%20bowl%20on%20a%20wooden%20table%20at%20night%2C%20steam%20rising%2C%20soft%20amber%20lamp%20light%2C%20cozy%20minimal%20food%20photography%2C%20muted%20warm%20tones&width=200&height=200&seq=rank-food-c&orientation=squarish" },
  { rank: 6, title: "古法琉璃的诞生", author: "器物志", category: "手工", views: "3,244.0万", trend: "flat", cover: "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20craftsman%20shaping%20molten%20glass%20in%20a%20workshop%2C%20glowing%20orange%20material%2C%20dark%20rustic%20interior%2C%20documentary%20craft%20photography%2C%20warm%20contrast%20lighting&width=200&height=200&seq=rank-craft-c&orientation=squarish" },
];

export const collections: CollectionItem[] = [
  {
    id: 1,
    name: "深夜治愈厨房",
    count: "8 部 · 一人食",
    theme: "美食",
    desc: "从一碗热汤面到深夜小食，把安静的夜晚做成有温度的一餐。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20night%20kitchen%20counter%20with%20warm%20lamp%2C%20simple%20home%20dishes%20and%20herbs%2C%20dark%20wood%20tones%2C%20cinematic%20food%20editorial%20photography&width=640&height=420&seq=col-food-01&orientation=landscape",
    tags: ["美食", "治愈", "独居"],
  },
  {
    id: 2,
    name: "环球旅行日记",
    count: "12 部 · 在路上",
    theme: "旅行",
    desc: "从海岸到雪山，收好每一段路上的日出、风声和陌生人的笑。",
    cover: "https://readdy.ai/api/search-image?query=Winding%20mountain%20road%20through%20misty%20valleys%20at%20golden%20hour%2C%20distant%20snow%20peaks%2C%20cinematic%20travel%20landscape%20photography%2C%20warm%20terracotta%20sky&width=640&height=420&seq=col-travel-02&orientation=landscape",
    tags: ["旅行", "纪录", "风景"],
  },
  {
    id: 3,
    name: "手作人的慢生活",
    count: "9 部 · 器物与时间",
    theme: "手工",
    desc: "看双手如何把材料变成器物，也看专注本身有多迷人。",
    cover: "https://readdy.ai/api/search-image?query=Artisan%20hands%20working%20clay%20and%20natural%20materials%20on%20a%20rustic%20workbench%2C%20scattered%20tools%2C%20warm%20earthy%20tones%2C%20documentary%20craft%20photography&width=640&height=420&seq=col-craft-03&orientation=landscape",
    tags: ["手工", "慢生活", "纪录"],
  },
  {
    id: 4,
    name: "萌宠爆笑名场面",
    count: "15 部 · 治愈每一天",
    theme: "宠物",
    desc: "毛孩子的高光与翻车合集，保证每一分钟都能笑出声。",
    cover: "https://readdy.ai/api/search-image?query=Playful%20puppy%20and%20kitten%20in%20a%20bright%20cozy%20living%20room%2C%20soft%20natural%20light%2C%20joyful%20cute%20pet%20lifestyle%20photography%2C%20warm%20tones&width=640&height=420&seq=col-pet-04&orientation=landscape",
    tags: ["萌宠", "治愈", "搞笑"],
  },
  {
    id: 5,
    name: "硬核数码拆解",
    count: "10 部 · 看懂参数",
    theme: "数码",
    desc: "把热门设备拆开给你看，参数背后到底藏着什么。",
    cover: "https://readdy.ai/api/search-image?query=Organized%20teardown%20workbench%20with%20electronic%20components%2C%20circuit%20boards%20and%20precision%20tools%2C%20clean%20studio%20lighting%2C%20minimal%20tech%20photography&width=640&height=420&seq=col-tech-05&orientation=landscape",
    tags: ["数码", "开箱", "教程"],
  },
  {
    id: 6,
    name: "城市漫游指南",
    count: "7 部 · 走街串巷",
    theme: "生活",
    desc: "不赶行程，只用一下午在熟悉的城市里发现新的角落。",
    cover: "https://readdy.ai/api/search-image?query=Quiet%20old%20city%20alley%20with%20shophouses%20and%20hanging%20signs%20at%20dusk%2C%20warm%20street%20lamps%2C%20nostalgic%20urban%20documentary%20photography&width=640&height=420&seq=col-city-06&orientation=landscape",
    tags: ["城市漫游", "生活", "Vlog"],
  },
];

export const creators: CreatorItem[] = [
  {
    id: 1,
    name: "阿凉的小厨房",
    field: "美食",
    followers: "128.4万",
    works: "342 部",
    avatar: "https://readdy.ai/api/search-image?query=Clean%20minimal%20portrait%20avatar%20of%20a%20young%20home%20cook%20in%20a%20warm%20kitchen%2C%20soft%20natural%20light%2C%20friendly%20editorial%20headshot%2C%20warm%20neutral%20background&width=200&height=200&seq=creator-food-01&orientation=squarish",
    bio: "把一日三餐做成看得见的安心，更新简单好上手的家常菜。",
  },
  {
    id: 2,
    name: "行路者阿哲",
    field: "旅行",
    followers: "276.1万",
    works: "189 部",
    avatar: "https://readdy.ai/api/search-image?query=Clean%20minimal%20portrait%20avatar%20of%20a%20young%20traveler%20with%20a%20backpack%20outdoors%2C%20soft%20warm%20light%2C%20friendly%20editorial%20headshot%2C%20muted%20earth%20background&width=200&height=200&seq=creator-travel-02&orientation=squarish",
    bio: "一年里有八个月在路上，专拍那些值得绕远路去看的风景。",
  },
  {
    id: 3,
    name: "喵星研究所",
    field: "宠物",
    followers: "512.3万",
    works: "401 部",
    avatar: "https://readdy.ai/api/search-image?query=Clean%20minimal%20portrait%20avatar%20of%20a%20person%20holding%20a%20fluffy%20cat%2C%20soft%20warm%20light%2C%20friendly%20editorial%20headshot%2C%20cozy%20cream%20background&width=200&height=200&seq=creator-pet-03&orientation=squarish",
    bio: "记录毛孩子的每一天，用最治愈的方式陪你度过碎片时间。",
  },
  {
    id: 4,
    name: "拆解君",
    field: "数码",
    followers: "87.6万",
    works: "156 部",
    avatar: "https://readdy.ai/api/search-image?query=Clean%20minimal%20portrait%20avatar%20of%20a%20young%20tech%20reviewer%20in%20a%20studio%2C%20soft%20cool%20light%2C%20friendly%20editorial%20headshot%2C%20neutral%20gray%20background&width=200&height=200&seq=creator-tech-04&orientation=squarish",
    bio: "把参数讲成人话，拆开每台热门设备看它到底值不值。",
  },
  {
    id: 5,
    name: "城市声场",
    field: "音乐",
    followers: "64.2万",
    works: "98 部",
    avatar: "https://readdy.ai/api/search-image?query=Clean%20minimal%20portrait%20avatar%20of%20a%20musician%20with%20an%20acoustic%20guitar%2C%20soft%20warm%20light%2C%20friendly%20editorial%20headshot%2C%20moody%20amber%20background&width=200&height=200&seq=creator-music-05&orientation=squarish",
    bio: "在天台、街角和livehouse里，把城市的声音现场带给你。",
  },
  {
    id: 6,
    name: "光影笔记",
    field: "影视",
    followers: "203.7万",
    works: "267 部",
    avatar: "https://readdy.ai/api/search-image?query=Clean%20minimal%20portrait%20avatar%20of%20a%20film%20enthusiast%20in%20a%20dim%20cinema%2C%20soft%20warm%20light%2C%20friendly%20editorial%20headshot%2C%20deep%20amber%20background&width=200&height=200&seq=creator-movie-06&orientation=squarish",
    bio: "只推真正值得花时间的片子，偶尔也聊聊镜头背后的故事。",
  },
];

export const hotTags: string[] = [
  "治愈", "美食", "旅行", "萌宠", "手工", "数码", "搞笑", "健身",
  "知识", "音乐", "影视", "穿搭", "独居", "城市漫游", "深夜放送", "慢生活",
  "Vlog", "教程", "开箱", "纪录", "户外", "咖啡", "手冲", "露营",
  "收纳", "极简", "复古", "成长", "职场", "亲子",
];

export const guideSteps = [
  {
    step: "01",
    title: "先看榜单定位",
    desc: "从「今日热门排行」开始，日榜看当下、周榜看稳定、总榜看长期口碑，几秒锁定方向。",
  },
  {
    step: "02",
    title: "按合集连着刷",
    desc: "喜欢一个题材就进「精选合集」，同一主题的内容已经按顺序整理好，不用一条条翻。",
  },
  {
    step: "03",
    title: "用标签精准筛选",
    desc: "在「内容探索」里输入关键词或点选标签，筛选只作用于本页内容，结果立刻呈现。",
  },
  {
    step: "04",
    title: "关注对味的创作者",
    desc: "遇到风格喜欢的作者，看看「优质创作者推荐」里他的其他作品，快速找到同类内容。",
  },
];

export const faqs: FaqItem[] = [
  {
    q: "这个小视频站点主要能帮我做什么？",
    a: "本页把当下热门的小视频合集与精选排行聚合在一起，包括热门榜单、主题合集、内容探索、创作者推荐等分区，帮助你快速浏览值得观看的内容，省去在多个平台之间来回翻找的麻烦。",
  },
  {
    q: "排行榜和合集多久更新一次？",
    a: "页面按日榜、周榜、总榜三种维度组织推荐内容，方便你从不同时间跨度做判断。当前为示例内容展示，后续接入数据源后可按实际更新频率滚动刷新。",
  },
  {
    q: "找不到想看的分类该怎么办？",
    a: "可以到「内容探索」分区，在搜索框输入关键词，或直接点选上方的分类标签。筛选与搜索都只作用于本页已有的内容，结果会立即显示，无需跳转或等待。",
  },
  {
    q: "「合集」和单条视频有什么区别？",
    a: "合集是按主题把多条内容组织在一起，适合连续观看、一次看个够；单条视频则更适合按兴趣点开，两者搭配使用，既能连着刷，也能快速看一条。",
  },
  {
    q: "这里的视频可以下载或收藏吗？",
    a: "本页仅用于内容浏览与推荐展示，不提供下载功能。收藏、点赞等需要账号的操作同样不在本页范围内，页面不接账号系统，也不做真实提交。",
  },
  {
    q: "浏览时我的操作数据会被记录吗？",
    a: "不会。本页为纯前端展示，所有筛选、搜索和标签切换都只在你的浏览器内完成，刷新后不会上传或保存任何个人数据。",
  },
];